import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, ControlLabel, Input, Form, SelectPicker, HelpBlock } from 'rsuite'
import { isRequired, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import NumberFormat from 'react-number-format'

export default function CenterAddBankAccountForm({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  changeGetBankBranch = () => {},
  ...props
}) {
  const [schema, setSchema] = useState()

  useEffect(() => {
    console.log('_schema => ', _schema)
    setSchema(_schema)
  }, [_schema])

  return (
    <>
      <Form>
        <Panel>
          <Row>
            {schema?.bankName && (
              <Col xs={24} sm={24} md={8} lg={8} style={{ marginTop: 15 }}>
                <ErrorMessage error={errors[schema.bankName.name]} />
                <ControlLabel>
                  {requiredFiled(schema.bankName.validators, schema.bankName.label)}
                </ControlLabel>
                <Controller
                  name={schema.bankName.name}
                  control={control}
                  defaultValue={schema?.bankName?.value || null}
                  rules={isValidators(schema.bankName.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        block
                        data={schema.bankName.options}
                        value={props.value}
                        disabled={schema.bankName.disabled}
                        searchable
                        placeholder={'เลือก' + schema.bankName.label}
                        onChange={(value) => {
                          props.onChange(value)
                          // console.log('value => ', value)
                          changeGetBankBranch(value || null)
                          //handleOnChangeSelectPicker(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            )}

            {schema?.bankBranch && (
              <Col xs={24} sm={24} md={8} lg={8} style={{ marginTop: 15 }}>
                <ErrorMessage error={errors[schema.bankBranch.name]} />
                <ControlLabel>
                  {requiredFiled(schema.bankBranch.validators, schema.bankBranch.label)}
                </ControlLabel>
                <Controller
                  name={schema.bankBranch.name}
                  control={control}
                  defaultValue={schema.bankBranch.value}
                  rules={isValidators(schema.bankBranch.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        block
                        data={schema.bankBranch.options}
                        value={props.value}
                        disabled={schema.bankBranch.disabled}
                        searchable
                        placeholder={'เลือก' + schema.bankBranch.label}
                        onChange={(value) => {
                          props.onChange(value)
                          //handleOnChangeSelectPicker(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            )}

            {schema?.bankAccountType && (
              <Col xs={24} sm={24} md={8} lg={8} style={{ marginTop: 15 }}>
                <ErrorMessage error={errors[schema.bankAccountType.name]} />
                <ControlLabel>
                  {requiredFiled(schema.bankAccountType.validators, schema.bankAccountType.label)}
                </ControlLabel>
                <Controller
                  name={schema.bankAccountType.name}
                  control={control}
                  defaultValue={schema?.bankAccountType?.value}
                  rules={isValidators(schema.bankAccountType.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        block
                        data={schema.bankAccountType.options}
                        value={props.value}
                        disabled={schema.bankAccountType.disabled}
                        // searchable
                        placeholder={'เลือก' + schema.bankAccountType.label}
                        onChange={(value) => {
                          props.onChange(value)
                          //handleOnChangeSelectPicker(value)
                        }}
                      />
                    )
                  }}
                />
              </Col>
            )}

            {schema?.bankAccountNumber && (
              <Col xs={24} sm={24} md={8} lg={8} style={{ marginTop: 15 }}>
                <ErrorMessage error={errors[schema.bankAccountNumber.name]} />
                <ControlLabel>
                  {requiredFiled(
                    schema.bankAccountNumber.validators,
                    schema.bankAccountNumber.label
                  )}
                </ControlLabel>
                <Controller
                  name={schema.bankAccountNumber.name}
                  control={control}
                  defaultValue={schema.bankAccountNumber.value}
                  rules={isValidators(schema.bankAccountNumber.validators)}
                  render={(props) => {
                    return (
                      <>
                        <Input
                          style={{ marginTop: 8 }}
                          placeholder={`ระบุ${schema.bankAccountNumber.label}`}
                          value={props.value}
                          disabled={schema.bankAccountNumber.disabled}
                          // type="number"
                          onChange={(value) => {
                            if (/^\d*$/.test(value)) {
                              props.onChange(value)
                            }
                            // console.log('value => ', isNaN(value), value)
                            // if (isNaN(value)) {
                            //   return
                            // } else {
                            //   props.onChange(value)
                            // }
                          }}
                        />
                        <HelpBlock style={{ fontSize: 12, marginTop: 5, marginLeft: 5 }}>
                          *กรุณากรอกเฉพาะตัวเลข 0-9 เท่านั้น
                        </HelpBlock>
                      </>
                    )
                  }}
                />
                {/* <Input
                  name={schema.bankAccountNumber.name}
                  defaultValue={schema.bankAccountNumber.value}
                  inputRef={register(isValidators(schema.bankAccountNumber.validators))}
                  type="number"
                  pattern="[0-9]+"
                  onChange={(value) => {
                    console.log('value => ', value.replace(/[^0-9]/g, ''))
                  }}
                /> */}
              </Col>
            )}

            {schema?.bankAccountName && (
              <Col xs={24} sm={24} md={16} lg={16} style={{ marginTop: 23 }}>
                <ErrorMessage error={errors[schema.bankAccountName.name]} />
                <ControlLabel>
                  {requiredFiled(schema.bankAccountName.validators, schema.bankAccountName.label)}
                </ControlLabel>
                <Input
                  name={schema.bankAccountName.name}
                  disabled={schema.bankAccountName.disabled}
                  defaultValue={schema.bankAccountName.value}
                  inputRef={register(isValidators(schema.bankAccountName.validators))}
                />
              </Col>
            )}
          </Row>
        </Panel>
      </Form>
    </>
  )
}
